/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import Link from 'next/link';
import classNames from 'classnames';
import styles from './logo.module.scss';
import SmartImage from '../../smartImage/smartImage';

export default function Logo({
  logo = {
    path: '',
    alt: '',
    link: '/',
  },
  mobileLogo = null,
  type = null,
  isSlim = false,
}) {
  const isPF = type === 'Patient Solutions';
  const logoLink = logo?.link || mobileLogo?.link || '/';

  return (
    <div
      className={classNames(styles.logo, {
        [styles.logoSlim]: isSlim,
      })}
    >
      <Link href={logoLink} className={styles.link}>
        {logo?.path && (
          <SmartImage
            className={
              isPF
                ? styles.pfLogo
                : classNames(styles.image, styles.desktopImage, {
                    [styles.desktopImageSlim]: isSlim,
                  })
            }
            alt={logo.alt}
            src={logo.path}
            height={logo?.height}
            width={logo?.width}
            priority
          />
        )}
        {mobileLogo?.path && !isPF && (
          <SmartImage
            className={classNames(styles.image, styles.mobileImage, {
              [styles.mobileImageSlim]: isSlim,
            })}
            alt={mobileLogo.alt}
            src={mobileLogo.path}
            height={mobileLogo?.height}
            width={mobileLogo?.width}
            priority
          />
        )}
      </Link>
    </div>
  );
}

Logo.propTypes = {
  logo: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
    link: PropTypes.string,
  }),
  mobileLogo: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
    link: PropTypes.string,
  }),
  type: PropTypes.string,
  isSlim: PropTypes.bool,
};
